import { Component, OnInit } from '@angular/core';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import * as moment from 'moment';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';

@Component({
  selector: 'app-carton-insert-report',
  templateUrl: './carton-insert-report.component.html',
  styleUrls: ['./carton-insert-report.component.scss']
})
export class CartonInsertReportComponent implements OnInit {
 date ;
 selectedDate : any = ""
  constructor(
    private apiService : ApiService,
    private apiConfig : ApiConfiguration,
    private exportExcelService : ExportExcelService
  ) { 
    let currentDate = new Date()
    this.date = moment(currentDate).format("YYYY-MM-DD")
    this.selectedDate = this.date
  }

  ngOnInit() {
  }

  

  filterListOfRecords(){
    this.apiService.get(this.apiConfig.liveReport + `?program_id=1&date=${this.date}&report_id=20`).subscribe((res : any)=>{
      console.log(res);
      this.downloadExcel(res.data.report_data)
    })
  }

  downloadExcel(data){
    let sheetName = "sheet1";
    let filename = "Carton_insert";
    let excelData = data;
    let excelArray = [
      { header: 'User Id', key: 'user_id'},
      { header: 'Osmosys Code', key: 'osmosys_code'},
      { header: 'Csm Mobile Number',key: 'csm_mobile_no'},
      { header: 'Start Date', key: 'start_date'},
      { header: 'End Date', key: 'end_date'},
      { header: 'Brand', key: 'brand' },
      { header: 'Points Per Case', key: 'points_per_case'},
      { header: 'Min', key: 'min'},
      { header: 'Max', key: 'max'},
      { header: 'Target', key: 'target_qty'},
      { header: 'Achievement',key: 'achievement'},
      { header: 'Achievement Percentage',key: 'achievement_percentage'},
      { header: 'Points Earned', key: 'points_earned'},
      { header: 'User Detail Name',    key: 'user_detail_name'}
    ]
    this.exportExcelService.DownloadstaticReportExcel(filename, sheetName, excelData, excelArray);
  }

}
